// Required modules
// See https://doc.babylonjs.com/setup/frameworkPackages/es6Support
import '@babylonjs/loaders/glTF';
// TODO à supprimer pour le build prod
// import '@babylonjs/inspector';

export * from "./runner"
